import React from 'react';

function SingleLoading({ width = '48px', height = '48px', className = '' }) {
  return (
    <div className={`flex justify-center items-center bg-none ${className}`}>
      <div
        className="rounded-full loading-circle"
        style={{
          width: width,
          height: height,
        }}
      ></div>
    </div>
  );
}
function Loading({ width = '48px', height = '48px', className = '' }) {
  return (
    <div className="text-center py-12 mt-2 h-fill-75 bg-light flex justify-center items-center">
      <SingleLoading width={width} height={height} className={className} />
      <SingleLoading width={width} height={height} className={className} />
      <SingleLoading width={width} height={height} className={className} />
    </div>
  );
}

export default Loading;

